export const prepareHtmlForPreview = (text: string) => {
	const div = document.createElement('div');
	div.innerHTML = text;
	div.querySelectorAll('p').forEach((p) => {
		// eslint-disable-next-line no-param-reassign
		p.style.paddingTop = '20px';
		// eslint-disable-next-line no-param-reassign
		p.style.margin = '0';
		if (!p.innerHTML) {
			// eslint-disable-next-line no-param-reassign
			p.innerHTML = '&nbsp;';
		}
	});
	div.querySelectorAll('ul').forEach((ul) => {
		// eslint-disable-next-line no-param-reassign
		ul.style.listStyleType = 'disc';
		// eslint-disable-next-line no-param-reassign
		ul.style.padding = '20px 0 0 40px';
	});
	div.querySelectorAll('ol').forEach((ol) => {
		// eslint-disable-next-line no-param-reassign
		ol.style.padding = '20px 0 0 40px';
		// eslint-disable-next-line no-param-reassign
		ol.style.margin = '0';
	});
	div.querySelectorAll('ins').forEach((ins) => {
		const innerContent = ins.innerHTML;
		const parent = ins.parentNode;
		const span = document.createElement('span');
		span.innerHTML = innerContent;
		span.style.textDecoration = 'underline';
		parent?.replaceChild(span, ins);
	});
	return div.innerHTML;
};

export const prepareHtmlToSend = (text: string) => {
	const table = document.createElement('table');
	const td = document.createElement('td');
	td.style.paddingTop = '20px';
	td.setAttribute('align', 'left');
	td.classList.add('padding');

	table.innerHTML = text;
	table.querySelectorAll('p, ul, ol').forEach((item) => {
		const elem = item as
			| HTMLParagraphElement
			| HTMLOListElement
			| HTMLUListElement;
		elem.style.margin = '0';
		elem.tagName === 'p'
			? (elem.style.padding = '0')
			: (elem.style.paddingTop = '0');

		const tr = document.createElement('tr');
		const tdElem = td.cloneNode(false);
		tdElem.appendChild(elem);
		tr.appendChild(tdElem);
		table.append(tr);
	});
	return table.innerHTML;
};

export const preparePlaintext = (text: string) => {
	const div = document.createElement('div');
	div.innerHTML = text;
	const elements = Array.from(div.querySelectorAll('p, ul, ol'));
	return elements.reduce((plaintext: string, el: Element) => {
		const stringData = el.textContent;
		return `${plaintext}${stringData}\n`;
	}, '');
};
